import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentPage = {
  footer: {
    root: 'loan-document.footer.root',
  },
  form: {
    h1: 'loan-document.form.h1',
    h2: 'loan-document.form.h2',
    root: 'loan-document.form.root',
    submitButton: 'loan-document.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document.header.drawer-button',
    root: 'loan-document.header.root',
  },
  progress: {
    root: 'loan-document.progress.root',
  },
} as const satisfies PageLocatorMap;
